import React, { useState } from 'react';
import { Button } from '../ui/button';

/**
 * Modal para visualizar o relatório de acessos a um horário
 */
const HorarioRelatorioAcessosModal = ({ 
  show, 
  relatorioAcessos, 
  onClose 
}) => {
  const [historicoColabExpandido, setHistoricoColabExpandido] = useState(null);

  if (!show || !relatorioAcessos) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="p-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            👁️ Relatório de Acessos ao Horário
          </h2>
          <Button variant="ghost" size="sm" onClick={onClose}>
            ✕
          </Button>
        </div>
        
        <div className="p-4 overflow-y-auto flex-1">
          {/* Resumo */}
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="bg-blue-50 p-3 rounded-lg text-center">
              <div className="text-2xl font-bold text-blue-600">{relatorioAcessos.total_colaboradores}</div>
              <div className="text-sm text-gray-600">Colaboradores viram</div>
            </div>
            <div className="bg-green-50 p-3 rounded-lg text-center">
              <div className="text-2xl font-bold text-green-600">{relatorioAcessos.total_acessos}</div>
              <div className="text-sm text-gray-600">Total de acessos</div>
            </div>
          </div>
          
          {/* Lista por colaborador */}
          <div className="space-y-2">
            <h3 className="font-medium text-sm text-gray-700 mb-2">Detalhes por Colaborador</h3>
            
            {relatorioAcessos.por_colaborador?.length > 0 ? (
              relatorioAcessos.por_colaborador.map((colab, idx) => (
                <div key={idx} className="border rounded-lg overflow-hidden">
                  <div 
                    className="flex items-center justify-between p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors"
                    onClick={() => setHistoricoColabExpandido(historicoColabExpandido === colab.colaborador_id ? null : colab.colaborador_id)}
                  >
                    <div>
                      <div className="font-semibold">{colab.colaborador_nome}</div>
                      <div className="text-sm text-gray-600">
                        Último acesso: {colab.ultimo_acesso ? new Date(colab.ultimo_acesso).toLocaleString('pt-PT') : '-'}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-medium text-blue-600">{colab.total_acessos} acesso(s)</div>
                      <div className="text-xs text-gray-500">
                        {historicoColabExpandido === colab.colaborador_id ? '▲ Fechar' : '▼ Ver datas'}
                      </div>
                    </div>
                  </div>
                  
                  {/* Histórico expandido */}
                  {historicoColabExpandido === colab.colaborador_id && (
                    <div className="bg-white p-3 border-t max-h-48 overflow-y-auto">
                      <div className="text-sm font-medium mb-2">📅 Histórico de Acessos:</div>
                      <div className="space-y-1">
                        {colab.acessos?.map((acesso, aIdx) => (
                          <div key={aIdx} className="flex items-center justify-between text-sm p-2 bg-gray-50 rounded">
                            <div className="flex items-center gap-2">
                              <span>📆</span>
                              <span>
                                {new Date(acesso.data_hora).toLocaleDateString('pt-PT', {
                                  weekday: 'short',
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                })}
                              </span>
                              <span className="text-gray-400">às</span>
                              <span className="font-medium">
                                {new Date(acesso.data_hora).toLocaleTimeString('pt-PT', {
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                Nenhum acesso registado ainda
              </div>
            )}
          </div>
        </div>
        
        <div className="p-4 border-t">
          <Button onClick={onClose} className="w-full">
            Fechar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HorarioRelatorioAcessosModal;
